import HeroCarousel from './components/HeroCarousel';
import CategoryQuickLinks from './components/CategoryQuickLinks';
import LatestSection from './components/LatestSection';
import HotRankList from './components/HotRankList';
import NewsFeed from './components/NewsFeed';
import HomeSidebar from './components/HomeSidebar';
import SiteIntro from './components/SiteIntro';

export default function Home() {
  return (
    <div className="w-full pb-4">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="pt-6 md:pt-8">
          <h1 className="font-heading font-extrabold text-2xl md:text-[32px] leading-tight text-foreground-950">
            快活影院 · 最新影视资源与观影指南
          </h1>
          <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-3xl">
            浏览最新电影与热播电视剧，查看详细的影视资料、分类筛选与观影资讯，轻松找到下一部想看的作品。
          </p>
        </div>

        <HeroCarousel />
        <CategoryQuickLinks />

        <div className="mt-12 md:mt-14 grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_320px] gap-8 lg:gap-10">
          <div className="space-y-12 md:space-y-14">
            <LatestSection />
            <HotRankList />
            <NewsFeed />
          </div>
          <HomeSidebar />
        </div>

        <SiteIntro />
      </div>
    </div>
  );
}